import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EvaTagComponent } from './eva-tag.component';

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
        EvaTagComponent
    ],
    declarations: [
        EvaTagComponent
    ],
    providers: [],
})
export class EvaTagModule { }
